export default __webpack_public_path__ + "static/media/1613.9fdcc26e.png";